<template lang="html">
  <walkthrough-stepper
    @close="$emit('close')"
    :pageTitles="page_titles"
    stepperTitle="Manage Students"
  >
    <template slot-scope="{ page }">
      <div class="mh3 ph4 flex-grow" v-show="page === 0">
        <div class="flex justify-center">
          <i class="fas fa-user-plus fa-3x ma3" />
        </div>
        <p class="pl-subheading">
          Manage your students in the RoundTable by clicking the
          <i class="fas fa-user-plus mh1" /> icon. You can invite students in
          one of three ways:
        </p>
        <ol class="pl-body-1 pl3">
          <li class="mb2">
            Select students who are already registered to your Parlay course.
          </li>
          <li class="mb2">
            Invite students by sharing a private RoundTable URL.
          </li>
          <li class="mb2">
            Share the invitation URL with your Google Classroom.
          </li>
        </ol>
      </div>
      <div class="mh3 pa3 flex-grow" v-show="page === 1">
        <div class="flex justify-center">
          <i class="fas fa-eye fa-3x ma3" />
        </div>
        <div class="pl-subheading">
          When <span class="italics">Anonymous Mode</span> is turned on the
          teacher can use this button to switch between the students secret
          identities and real ones.
        </div>
      </div>
    </template>
  </walkthrough-stepper>
</template>
<script>
  import WalkthroughStepper from 'features/onlineWalkthrough/onlineWalkthroughStepper';

  export default {
    data() {
      return {
        page_titles: ['Invitations', 'View Secret Identities'],
      };
    },
    components: {
      WalkthroughStepper,
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// onlineWalkthroughStudentlist.vue?4f68de12